export const setCustomerNumber = (number) => {
    return {
        type: 'CustomerNumber',
        data: {
          number: number,
        },
        payload: number,
    }
};

export const setCustomerEmail = (email) => {
    return {
        type: 'Customer_Email',
        email: email,
    }
};



// WEBPACK FOOTER //
// ./src/components/CoreLayout/actions.js